import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const PartnerList = Loadable(lazy(() => import('./PartnerList')));
const AddPartner = Loadable(lazy(() => import('./AddPartner')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const PartnerRoutes = [
  {
    path: '/Partner/list',
    element: (
      //<PrivateRoute pageUrl="PartnerMaster" requiredFunc="VIE">
        <PartnerList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/Partner/manage',
    element: (
      <PrivateRoute pageUrl="PartnerMaster" requiredFunc="ADD">
        <AddPartner />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default PartnerRoutes;
